import styled from "styled-components";

export const ModalTitle = styled.h2`
  margin: 0;
  color: var(--mono-500, #2c2c31);
  text-align: center;
  font-feature-settings:
    "liga" off,
    "clig" off;
  font-family: Poppins, sans-serif;
  font-size: 28px;
  font-style: normal;
  font-weight: 700;
`;

export const ModalSubTitle = styled.p`
  margin: 0;
  margin-top: 8px;
  color: var(--Typography-02-Low-Emphasis-Text, #737377);
  text-align: center;
  font-feature-settings:
    "liga" off,
    "clig" off;
  font-family: Overpass, sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  white-space: pre-line;
`;

export const InputLabel = styled.label`
  display: block;
  margin-top: 16px;
  color: var(--typography-01-high-emphasis-text-he, #181b25);
  font-feature-settings:
    "liga" off,
    "clig" off;
  font-family: Overpass, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
`;

export const NickNameInput = styled.input`
  display: block;
  margin-top: 4px;
  height: 48px;
  border: 1px solid ${({ theme }) => theme.colors.periwinkle[500]};
  box-sizing: border-box;
  border-radius: 8px;
  padding: 0 16px;
  width: 100%;
  font-size: ${({ theme }) => theme.fontSizes["md"]};

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.brand[500]};
  }

  &::placeholder {
    color: ${({ theme }) => theme.colors.neutral[400]};
  }
`;

export const HelperText = styled.p<{ $isError?: boolean }>`
  margin: 0;
  margin-top: 4px;
  margin-bottom: 24px;
  color: ${({ $isError, theme }) =>
    $isError
      ? theme.colors.red[100]
      : "var(--typography-02-low-emphasis-text-le, #72839e)"};
  font-feature-settings:
    "liga" off,
    "clig" off;
  font-family: Overpass, sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;

export const ModalContent = styled.div`
  width: 100%;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  justify-content: center;
`;

export const SkipButton = styled.button`
  background: none;
  border: none;
  color: var(--Typography-05---Activity-Text, #1e5af6);
  text-align: center;
  font-feature-settings:
    "liga" off,
    "clig" off;
  font-family: Poppins, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
  cursor: pointer;
  padding: 8px;
  transition: color 0.2s ease;

  &:hover {
    opacity: 0.8;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const ErrorText = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.red[100]};
  font-size: ${({ theme }) => theme.fontSizes["sm"]};
`;

export const SuccessImageContainer = styled.div`
  margin: 0;
  display: flex;
  justify-content: center;
  padding: 0;
`;

export const SuccessTitle = styled.h2`
  margin: 0;
  margin-top: 16px;
  color: var(--mono-500, #2c2c31);
  text-align: center;
  font-feature-settings:
    "liga" off,
    "clig" off;
  font-family: Poppins, sans-serif;
  font-size: 28px;
  font-style: normal;
  font-weight: 700;
`;

export const SuccessSubTitle = styled.p`
  margin: 0;
  margin-top: 8px;
  margin-bottom: 24px;
  color: var(--Typography-02-Low-Emphasis-Text, #737377);
  text-align: center;
  font-feature-settings:
    "liga" off,
    "clig" off;
  font-family: Overpass, sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  white-space: pre-line;
`;
